export default __webpack_public_path__ + "static/media/Approve.db07b6fe.png";